import {UntypedFormGroup, UntypedFormControl, Validators} from '@angular/forms';

export class CommsMessageModel {
  commsMessageForm = new UntypedFormGroup({
    'parties': new UntypedFormControl([], [Validators.required]),
    'subject': new UntypedFormControl('', [
      Validators.required,
    ]),
    'message': new UntypedFormControl('', [
      Validators.required,
    ])
  });
}
